{
  "CUSTOM_ROLE": {
    "HEADER": "自定义角色",
    "LEARN_MORE": "了解更多关于自定义角色的信息",
    "DESCRIPTION": "自定义角色是由账户所有者或管理员创建的角色。这些角色可以分配给客服人员，以定义他们在账户中的访问权限和权限。自定义角色可以根据组织的需求创建特定的权限和访问级别。",
    "COUNT": "{n} custom role | {n} custom roles",
    "HEADER_BTN_TXT": "添加自定义角色",
    "LOADING": "正在获取自定义角色……",
    "SEARCH_PLACEHOLDER": "Search custom roles...",
    "NO_RESULTS": "No custom roles found matching your search",
    "SEARCH_404": "没有任何项目符合此查询。",
    "PAYWALL": {
      "TITLE": "升级以创建自定义角色",
      "AVAILABLE_ON": "自定义角色功能仅在商务版和企业版计划中可用。",
      "UPGRADE_PROMPT": "升级您的计划以获取团队管理、自动化、自定义属性等高级功能。",
      "UPGRADE_NOW": "立即升级",
      "CANCEL_ANYTIME": "您可以随时更改或取消您的计划"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "自定义角色功能仅在付费计划中可用。",
      "UPGRADE_PROMPT": "升级到付费计划以访问审计日志、客服容量等高级功能。",
      "ASK_ADMIN": "请联系您的管理员进行升级。"
    },
    "LIST": {
      "404": "此账户中没有可用的自定义角色。",
      "TITLE": "管理自定义角色",
      "DESC": "自定义角色是由账户所有者或管理员创建的角色。这些角色可以分配给客服人员，以定义他们在账户中的访问权限和权限。自定义角色可以根据组织的需求创建特定的权限和访问级别。",
      "TABLE_HEADER": {
        "NAME": "姓名",
        "DESCRIPTION": "描述",
        "PERMISSIONS": "权限",
        "ACTIONS": "操作"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "管理所有对话",
      "CONVERSATION_UNASSIGNED_MANAGE": "管理未分配的对话及分配给他们的对话",
      "CONVERSATION_PARTICIPATING_MANAGE": "管理参与的对话及分配给他们的对话",
      "CONTACT_MANAGE": "管理联系人",
      "REPORT_MANAGE": "管理报告",
      "KNOWLEDGE_BASE_MANAGE": "管理知识库"
    },
    "FORM": {
      "NAME": {
        "LABEL": "姓名",
        "PLACEHOLDER": "请输入名称。",
        "ERROR": "名称是必填项。"
      },
      "DESCRIPTION": {
        "LABEL": "描述",
        "PLACEHOLDER": "请输入描述。",
        "ERROR": "描述是必需的。"
      },
      "PERMISSIONS": {
        "LABEL": "权限",
        "ERROR": "权限是必需的。"
      },
      "CANCEL_BUTTON_TEXT": "取消",
      "API": {
        "ERROR_MESSAGE": "无法与 Woot 服务器建立连接。请重试。"
      }
    },
    "ADD": {
      "TITLE": "添加自定义角色",
      "DESC": "自定义角色允许您创建具有特定权限和访问级别的角色，以满足组织的需求。",
      "SUBMIT": "提交",
      "API": {
        "SUCCESS_MESSAGE": "自定义角色添加成功。"
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "编辑",
      "TITLE": "编辑自定义角色",
      "DESC": "自定义角色允许您创建具有特定权限和访问级别的角色，以满足组织的需求。",
      "SUBMIT": "更新",
      "API": {
        "SUCCESS_MESSAGE": "自定义角色更新成功。"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "删除",
      "API": {
        "SUCCESS_MESSAGE": "自定义角色删除成功。",
        "ERROR_MESSAGE": "无法与 Woot 服务器建立连接。请重试。"
      },
      "CONFIRM": {
        "TITLE": "确认删除",
        "MESSAGE": "您确定要删除吗 ",
        "YES": "是的，删除",
        "NO": "不，保留"
      }
    }
  }
}
